import { NavLink, useNavigate } from "react-router-dom";
import { Dumbbell, ListVideo, LogOut, Monitor, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function StaffNavigation() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const commandPath = user?.role === "admin" ? "/admin/patients" : "/my-patients";
  const links = [
    { to: commandPath, label: "Command Centre", icon: Monitor },
    { to: "/admin/exercises", label: "Exercise Library", icon: Dumbbell },
    { to: "/admin/playlists", label: "Playlists", icon: ListVideo },
  ];
  if (user?.role === "admin") links.unshift({ to: "/admin", label: "Admin Home", icon: Shield });

  const signOut = async () => {
    await logout();
    navigate("/auth", { replace: true });
  };

  return <nav className="flex flex-wrap items-center gap-1 rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm" aria-label="Staff navigation">
    {links.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} className={({ isActive }) => `inline-flex h-9 items-center gap-2 rounded-xl px-3 text-xs font-semibold ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}><Icon size={15} />{label}</NavLink>)}
    <button type="button" onClick={signOut} className="inline-flex h-9 items-center gap-2 rounded-xl px-3 text-xs font-semibold text-slate-600 hover:bg-slate-50"><LogOut size={15} />Log out</button>
  </nav>;
}
